// Deployment configuration for Hashers Not Trashers.
// Each field from window.RUNTIME_CONFIG (the /config.js the deploy serves),
// then the build's env, then a default.

import { cognitoFields, createDeploymentConfig } from "@jkast90/kast-common/config";

/** localhost and 127.0.0.1 only, as before ([::1] gets the deployed API). */
export function defaultApiUrl(hostname: string): string {
  return hostname === "localhost" || hostname === "127.0.0.1"
    ? "http://localhost:8444"
    : "https://api.kast-dev.net/hnt-api";
}

export const deploymentConfig = createDeploymentConfig({
  env: import.meta.env,
  // No per-device overrides.
  storage: null,
  fields: {
    apiUrl: {
      key: "VITE_HNT_API_BASE_URL",
      default: ({ hostname }) => defaultApiUrl(hostname),
    },
    ...cognitoFields(),
  },
});

export const getDeploymentConfig = deploymentConfig.get;
